import Vue from "vue";
import FastClick from "fastclick";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import config from "./config/config";
import "@/public/css/common.css"; //初始化样式
import "@/public/css/ui.css"; //初始化样式
import axiosInstance from "./utils/axios";
import api from "./api";
import registerFilter from "./utils/filters";
import "./utils/directives";
import { build_wechat, build_h5 } from "@/helper/types/build";
import { initGustInfo } from "./utils/auth";
// import Vconsole from 'vconsole';

// new Vconsole()

//初始化顾客信息
initGustInfo();

//是否在微信环境打包
Vue.prototype.$isBuildWechat = config.BUILD_TYPE == build_wechat;

Vue.config.productionTip = false;
//vue原型挂载配置
Vue.prototype.$config = config;
Vue.prototype.$axios = axiosInstance;
Vue.prototype.$api = api;
//注册过滤器
registerFilter(Vue);

FastClick.prototype.focus = function(targetElement) {
    targetElement.focus();
};
//处理移动端点击事件延迟
FastClick.attach(document.body);

// 设置html字体大小
function setHtmlFontSize(zoom) {
    const max_width = 750;
    let winWidth = document.documentElement.clientWidth || window.screen.width;
    let html = document.getElementsByTagName("html")[0];
    if (winWidth >= max_width) {
        winWidth = max_width;
    }
    html.style.fontSize = winWidth / zoom + "px";
}

setHtmlFontSize(20);

window.onresize = function() {
    setHtmlFontSize(20);
};

const app = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
